import dateUtil from './dateUtil';

const getTodayDateTimeInTimezone = (timezone: string, format: string): string => dateUtil().tz(timezone).format(format);

export default getTodayDateTimeInTimezone;
